
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom'; // Importer NavLink
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Home.css';
import video from '../Assets/3141210-uhd_3840_2160_25fps.mp4';
import Header from './Header';
import partner1Logo from '../Assets/abb-group-baldor-electric-company-manufacturing-logo-png-favpng-Xf1YTJzFRh1S1DukKUp39vid0-removebg-preview.png';
import partner2Logo from '../Assets/png-clipart-pt-schneider-electric-manufacturing-batam-lot-04-logo-industrias-electronicas-pacifico-s-a-de-c-v-schneider-electric-chile-s-a-elektrik-logo-text-logo-thumbnail-removebg-preview.png';
import partner3Logo from '../Assets/logo-omron-healthcare-co-ltd-brand-microscan-systems-inc-business-removebg-preview.png';
import partner4Logo from '../Assets/png-clipart-siemens-building-technologies-logo-manufacturing-high-definition-video-diamond-letter-miscellaneous-blue-removebg-preview.png';
import MaintenanceIcon from '../Assets/Maintenance.png';
import SoftwareIcon from '../Assets/Software Engineering.png';
import EngineeringIcon from '../Assets/Engineering.png';
import IndustrialIcon from '../Assets/Engineering industrial.png';
import Industrialiconbleu from '../Assets/Gearbleu.png';
import Maintenanceiconbleu from '../Assets/Maintenancebleu.png';
import softwareenginneringbleu from '../Assets/Software Engineeringbleu.png';
import machineengineeringbleu from '../Assets/Settingsbleu.png';

// Données pour les partenaires
const partners = [
  { id: 1, name: 'Partner 1', logo: partner1Logo },
  { id: 2, name: 'Partner 2', logo: partner2Logo },
  { id: 3, name: 'Partner 3', logo: partner3Logo },
  { id: 4, name: 'Partner 4', logo: partner4Logo },
];

const Home = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fonction pour naviguer vers une route spécifique
  const handleSectorClick = (path) => {
    navigate(path);
  };

  const handleDiscover = () => {
    navigate('/aboutus');
  };

  // Paramètres pour le slider principal
  const mainSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    swipe: true,
    touchThreshold: 10,
    arrows: false,
    dotsClass: 'slick-dots custom-dots',
    pauseOnHover: false,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          swipe: true,
        },
      },
    ],
  };

  // Paramètres pour le slider des partenaires
  const partnerSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '0px',
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '0px',
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0px',
        },
      },
    ],
  };

  return (
    <div className="home-wrapper">
      <div className="home-container">
        <video className="background-video" autoPlay loop muted playsInline>
          <source src={video} type="video/mp4" />
          Votre navigateur ne supporte pas la vidéo.
        </video>
        <div className="video-overlay"></div>
        <div className="carousel-container">
          <Slider {...mainSliderSettings}>
            <div className="slide">
              <h2>Maintenance</h2>
            </div>
            <div className="slide">
              <h2>
                <span className="title-part">Software</span>
                <span className="title-part">Engineering</span>
              </h2>
            </div>
            <div className="slide">
              <h2>
                <span className="title-part">Machine</span>
                <span className="title-part">Engineering</span>
              </h2>
            </div>
            <div className="slide">
              <h2>
                <span className="title-part">Industrial</span>
                <span className="title-part">Engineering</span>
              </h2>
            </div>
          </Slider>
        </div>
      </div>
      <div className="additional-content">
        <div className="image-overlay"></div>
        <h2 className="partners-title">Nos Partenaires</h2>
        <p>nous concevons des solutions synergiques qui renforcent la valeur ajoutée et garantissent des résultats exceptionnels</p>
        <div className="partners-slider-container">
          <Slider {...partnerSliderSettings}>
            {partners.map((partner) => (
              <div key={partner.id} className="partner-slide">
                <img src={partner.logo} alt={partner.name} className="partner-logo" />
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <div className='divmultiple'>
        <h2>Domaines <span>d’innovation</span></h2>
        <p>Nous offrons des solutions innovantes adaptées à divers secteurs <br /><span>notamment dans le domaine des technologies avancées</span></p>
        <br />
        <div className="sectors-grid">
          <div
            className="sector-card sector-card-1"
            onClick={() => handleSectorClick('/technology')}
          >
            <h4 className="sector-title">Technologies</h4>
          </div>
          <div
            className="sector-card sector-card-2"
            onClick={() => handleSectorClick('/Utilities')}
          >
            <h4 className="sector-title">Service public</h4>
          </div>
          <div
            className="sector-card sector-card-3"
            onClick={() => handleSectorClick('/Infrastructure')}
          >
            <h4 className="sector-title">Infrastructures</h4>
          </div>
          <div
            className="sector-card sector-card-4"
            onClick={() => handleSectorClick('/energy')}
          >
            <h4 className="sector-title">Énergie</h4>
          </div>
          <div
            className="sector-card sector-card-5"
            onClick={() => handleSectorClick('/Industry')}
          >
            <h4 className="sector-title">Industries de procédés</h4>
          </div>
          <div
            className="sector-card sector-card-6"
            onClick={() => handleSectorClick('/Routes&transports')}
          >
            <h4 className="sector-title">Routes et transports</h4>
          </div>
          <div
            className="sector-card sector-card-7"
            onClick={() => handleSectorClick('/Pétrole')}
          >
            <h4 className="sector-title">Pétrole et gaz</h4>
          </div>
          <div
            className="sector-card sector-card-8"
            onClick={() => handleSectorClick('/Automatisation')}
          >
            <h4 className="sector-title">Automatisation</h4>
          </div>
        </div>
      </div>
      <br /><br />
      <div className='sevices'>
        <div className='titreservices'>
          <h2>Offre de <span>services</span></h2>
        </div>
        <div className='servicesp'>
          <p>Découvrez notre gamme complète de services conçus <br />
             <span>pour répondre à vos besoins spécifiques</span></p>
        </div>
        <div className="icons">
          <br />
          <div className="div1">
            <div className="icon-circle">
              <img src={MaintenanceIcon} alt="Maintenance" className="icon" />
              <img src={Maintenanceiconbleu} alt="Maintenance Bleu" className="icon-bleu" />
            </div>
            <div className="iconpluslink">
              <span className="divtext">Maintenance</span>
              <p>Providing comprehensive maintenance solutions to ensure seamless operations and prolong the lifespan of critical assets</p>
              <NavLink
                to="/Maintenance"
                className="view-more-link"
                style={{ color: '#00aaff', fontSize: '0.9rem', textDecoration: 'none' }}
              >
                Voir plus
              </NavLink>
            </div>
          </div>
          <div className="div1">
            <div className="icon-circle">
              <img src={SoftwareIcon} alt="Analyse Vibratoire" className="icon" />
              <img src={softwareenginneringbleu} alt="Software Engineering Bleu" className="icon-bleu" />
            </div>
            <div className="iconpluslink">
              <span className="divtext">Analyse Vibratoire</span>
              <p>Développement de solutions logicielles innovantes dédiées à l’analyse vibratoire pour optimiser la maintenance prédictive et améliorer les performances industrielles.</p>
              <NavLink
                to="/Analysevibratoire"
                className="view-more-link"
                style={{ color: '#00aaff', fontSize: '0.9rem', textDecoration: 'none' }}
              >
                Voir plus
              </NavLink>
            </div>
          </div>
          <div className="div1">
            <div className="icon-circle">
              <img src={EngineeringIcon} alt="Machine Engineering" className="icon" />
              <img src={machineengineeringbleu} alt="Machine Engineering Bleu" className="icon-bleu" />
            </div>
            <div className="iconpluslink">
              <span className="divtext">Machine Engineering</span>
              <p>Designing and innovating advanced machinery solutions to maximize performance and operational excellence</p>
              <NavLink
                to="/machine-engineering"
                className="view-more-link"
                style={{ color: '#00aaff', fontSize: '0.9rem', textDecoration: 'none' }}
              >
                Voir plus
              </NavLink>
            </div>
          </div>
          <div className="div1">
            <div className="icon-circle">
              <img src={IndustrialIcon} alt="Industrial Engineering" className="icon" />
              <img src={Industrialiconbleu} alt="Industrial Engineering Bleu" className="icon-bleu" />
            </div>
            <div className="iconpluslink">
              <span className="divtext">Industrial Engineering</span>
              <p>Optimizing processes and systems to enhance efficiency, productivity, and profitability for your business</p>
              <NavLink
                to="/industrial-engineering"
                className="view-more-link"
                style={{ color: '#00aaff', fontSize: '0.9rem', textDecoration: 'none' }}
              >
                Voir plus
              </NavLink>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <button className='découvrez' onClick={handleDiscover}>Découvrir plus</button>
      </div>
      <br />
    </div>
  );
};

export default Home;